export const INITIAL_ALLOC_FILE_STATE = { name: '', description: '', file: '' };
export const UPLOAD_ACCEPTED_FILES = ['.xlsx', '.xls'];
